export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref11307.b7390747.jpg";